/**
 * CV Ranking API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ReqTypeModel = 'SUMMARY' | 'EXPERIENCE' | 'GEMINI_SUMMARY' | 'GEMINI_EXPERIENCE';

export const ReqTypeModel = {
    Summary: 'SUMMARY' as ReqTypeModel,
    Experience: 'EXPERIENCE' as ReqTypeModel,
    GeminiSummary: 'GEMINI_SUMMARY' as ReqTypeModel,
    GeminiExperience: 'GEMINI_EXPERIENCE' as ReqTypeModel
};

